import { FC } from "react";
import cn from "classnames";
import styles from "./Instruction.module.sass";

export enum INSTRUCTION_STATE_TYPES {
	CIRCLES = "circles",
	SQUARES = "squares",
}

interface InstructionProps {
	type?: INSTRUCTION_STATE_TYPES;
}

const Instruction: FC<InstructionProps> = ({ type = INSTRUCTION_STATE_TYPES.CIRCLES }) => {
	const isCircle = type === INSTRUCTION_STATE_TYPES.CIRCLES ? styles.circle : styles.square;

	return (
		<div data-comment-false={true} className={styles.circles}>
			<div className={styles.legend}>Легенда:</div>
			<div className={styles.item}>
				<div className={cn(styles.figure, isCircle, styles.blue)}></div>
				<div className={styles.text}>Модель угроз сформирована</div>
			</div>
			<div className={styles.item}>
				<div className={cn(styles.figure, isCircle, styles.green)}></div>
				<div className={styles.text}>Категория присвоена</div>
			</div>
			<div className={styles.item}>
				<div className={cn(styles.figure, isCircle, styles.gray)}></div>
				<div className={styles.text}>Ожидает формирования модели угроз</div>
			</div>
			{/* <div className={styles.item}>
        <div className={cn(styles.figure, isCircle, styles.brown)}></div>
        <div className={styles.text}>Данные отправлены в ФСТЕК</div>
      </div> */}
			<div className={styles.item}>
				<div className={cn(styles.figure, isCircle, styles.purple)}></div>
				<div className={styles.text}>Повторное категорирование</div>
			</div>
		</div>
	);
};

export default Instruction;
